var map = {
	"./amex.svg": 5974,
	"./diners.svg": 2768,
	"./discover.svg": 5510,
	"./jcb.svg": 8844,
	"./mastercard.svg": 3531,
	"./other.svg": 2795,
	"./visa.svg": 44
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9867;